void (function () {
  if (typeof jQuery === "undefined") {
    console.error("[Klaviyo] jQuery is required but not loaded");
    return;
  }

  const $ = jQuery;

  // Handles Klaviyo API interactions for back in stock notifications and email subscriptions
  class KlaviyoApiHandler {
    constructor() {
      // API configuration for Klaviyo integration
      this.config = {
        PUBLIC_API_KEY: "WkTqs3",
        LIST_IDS: {
          CUSTOMER_EMAILS: "S9VwsA", // General customer email list
          CUSTOMER_EMAILS_FRANCE: "Sz3pfy", // French customer email list
          CUSTOMER_EMAILS_GERMANY: "VUdpun", // German customer email list
          RESTOCKING_SOON: "RzAaAa", // Restock notifications list
        },
        ENDPOINTS: {
          BACK_IN_STOCK:
            "https://a.klaviyo.com/client/back-in-stock-subscriptions/",
          SUBSCRIPTION: "https://a.klaviyo.com/client/subscriptions/",
        },
      };

      this.initializeEventListeners();
    }

    initializeEventListeners() {
      $(document).on(
        "click",
        "#back-in-stock.klaviyo-app #notify",
        this.handleBackInStockForm.bind(this)
      );
      $(document).on(
        "click",
        "#restocking-soon.klaviyo-app #restocking_soon_notify",
        this.handleRestockingSoonForm.bind(this)
      );
      $(document).on(
        "click",
        "#coming-soon.klaviyo-app #coming_soon_notify",
        this.handleComingSoonForm.bind(this)
      );
      $(document).on(
        "click",
        `#back-in-stock.stoq-app #notify, 
        #coming-soon.stoq-app #coming_soon_notify, 
        #restocking-soon.stoq-app #restocking_soon_notify`,
        this.handleSignupForNewsAndOffers.bind(this)
      );
    }

    // RFC 5322 compliant email validation
    validateEmail(email, inputSelector) {
      const emailPattern =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValid = emailPattern.test(email);

      if (!isValid) {
        $(inputSelector)
          .val("")
          .attr("placeholder", "Please enter a valid email")
          .addClass("error");
      } else {
        $(inputSelector).removeClass("error");
      }

      return isValid;
    }

    // Back in Stock Success Callbacks
    onBackInStockSuccess(email, variantID) {
      console.info("[Klaviyo] Back in stock subscription successful", {
        email,
        variantID,
      });
    }

    // Email List Subscription Success Callbacks
    onListSubscriptionSuccess(email, list, source) {
      console.info("[Klaviyo] Email subscription successful", {
        email,
        list,
        source,
      });
    }

    // Back in Stock Subscription Error Callbacks
    onBackInStockError(error, email, variantID) {
      console.error("[Klaviyo] Back in stock subscription failed", {
        error: error.message,
        email,
        variantID,
      });
    }

    // Email List Subscription Error Callbacks
    onListSubscriptionError(error, email, listId) {
      console.error("[Klaviyo] List subscription failed", {
        error: error.message,
        email,
        listId,
      });
    }

    // Update back in stock UI
    updateBackInStockUI() {
      console.log('saa_test:', 'updateBackInStockUI fn ran', );
      
      $("div#back-in-stock").removeClass("show");
      $(".ProductForm__AddToCart").css("display", "none");
      $(".notify-success-message").css("display", "block");
      $(".SizeSwatch").css("pointer-events", "none");

      // Reset UI after 5 seconds
      setTimeout(() => {
        $(".notify-success-message").css("display", "none");
        $(".ProductForm__AddSize").removeClass("hide");
        $(".ProductForm__AddSize").css("display", "block");
        $("span.ProductForm__Label.ProductForm__quantity_Label").css(
          "display",
          "block"
        );
        $(".ProductForm__QuantitySelector").css("display", "block");
        $(".SizeSwatch").css("pointer-events", "auto");
      }, 5000);
    }

    // Update UI for restocking soon
    updateRestockingSoonUI() {
      $("#restocking-soon .input-button-wrapper").css("display", "none");
      $("#restocking-soon .notify-success-message").css("display", "block");

      // Reset UI after 5 seconds
      setTimeout(() => {
        $("#restocking-soon .notify-success-message").css("display", "none");
        $("#restocking-soon .input-button-wrapper").css("display", "block");
      }, 5000);
    }

    // Update UI for coming soon
    updateComingSoonUI() {
      $("#coming-soon .input-button-wrapper").css("display", "none");
      $("#coming-soon .notify-success-message").css("display", "block");

      // Reset UI after 5 seconds
      setTimeout(() => {
        $("#coming-soon .notify-success-message").css("display", "none");
        $("#coming-soon .input-button-wrapper").css("display", "block");
      }, 5000);
    }

    // Handle signup for news and offers
    async handleSignupForNewsAndOffers(e) {
      e.preventDefault();

      const email = $(`.stoq-app input[type="email"]`).val();
      if (!this.validateEmail(email, `.stoq-app input[type="email"]`)) {
        return;
      }

      let klaviyoListId = this.config.LIST_IDS.CUSTOMER_EMAILS;
      let klaviyoListName = "Customer Emails";

      if (document.body.classList.contains('localization-country-fr')) {
        klaviyoListId = this.config.LIST_IDS.CUSTOMER_EMAILS_FRANCE;
        klaviyoListName = "Customer Emails French";
      } else if (document.body.classList.contains('localization-country-de')) {
        klaviyoListId = this.config.LIST_IDS.CUSTOMER_EMAILS_GERMANY;
        klaviyoListName = "Customer Emails German";
      }

      // Subscribe to customer emails if checkbox is checked
      if (document.querySelector(`.stoq-app input[type="checkbox"]`).checked && email) {
        this.subscribeToAList(
          email,
          klaviyoListId,
          klaviyoListName,
          "Sign me up for news and offers checkbox"
        )

        // Get language
        var lang = '';
        if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
          lang = window.Weglot.getCurrentLang();
        }
        if (!lang) {
          lang = document.documentElement.getAttribute('lang') || 'en';
        }

        // Same pattern as identifyLanguageToKlaviyo — retry until ready
        var sendLang = function() {
          // Send lang to Klaviyo profile (using klaviyo object instead of _learnq)
          // https://developers.klaviyo.com/en/docs/introduction_to_the_klaviyo_object#update-_learnq-code-to-use-klaviyo
        
          var klaviyoInstance = window.klaviyo;
          if (!klaviyoInstance || typeof klaviyoInstance.push !== 'function') {
            window.setTimeout(sendLang, 500);
            return;
          }
          klaviyoInstance.push(['identify', { '$email': email, 'lang': lang }]);
        };

        sendLang();
      }
    }

    // Handle back in stock form submission
    async handleBackInStockForm(e) {
      e.preventDefault();

      const email = $("#notify_email").val();
      if (!this.validateEmail(email, "#notify_email")) {
        return;
      }

      const variantID = $(".ProductForm__Variants select")
        .find(":selected")
        .val();
      const apiCalls = [];

      // Subscribe to customer emails if checkbox is checked
      if (document.querySelector("input#bis-newsletter").checked) {
        apiCalls.push(
          this.subscribeToAList(
            email,
            this.config.LIST_IDS.CUSTOMER_EMAILS,
            "Customer Emails",
            "Back in stock form"
          )
        );
      }

      // Add back in stock subscription
      apiCalls.push(this.backInStockSubscription(email, variantID));

      try {
        await Promise.all(apiCalls);
        this.updateBackInStockUI();
      } catch (error) {
        console.error("[Klaviyo] Form submission failed", {
          error: error.message,
        });
      }
    }

    // Handle restocking soon form submission
    async handleRestockingSoonForm(e) {
      e.preventDefault();

      const email = $("#restocking_soon_notify_email").val();
      if (!this.validateEmail(email, "#restocking_soon_notify_email")) {
        return;
      }

      const variantID = $(".ProductForm__Variants select")
        .find(":selected")
        .val();
      const apiCalls = [];

      // Subscribe to customer emails list if checkbox is checked
      if (document.querySelector("input#coming_soon_bis-newsletter").checked) {
        apiCalls.push(
          this.subscribeToAList(
            email,
            this.config.LIST_IDS.CUSTOMER_EMAILS,
            "Restocking Soon",
            "Restocking soon form"
          )
        );
      }

      // Subscribe to restocking soon list
      apiCalls.push(
        this.subscribeToAList(
          email,
          this.config.LIST_IDS.RESTOCKING_SOON,
          "Restocking Soon",
          "Restocking soon form"
        )
      );

      // Add back in stock subscription
      apiCalls.push(this.backInStockSubscription(email, variantID));

      try {
        await Promise.all(apiCalls);
        this.updateRestockingSoonUI();
      } catch (error) {
        console.error("[Klaviyo] Form submission failed", {
          error: error.message,
        });
      }
    }

    // Handle coming soon form submission
    async handleComingSoonForm(e) {
      e.preventDefault();

      const email = $("#coming_soon_notify_email").val();
      if (!this.validateEmail(email, "#coming_soon_notify_email")) {
        return;
      }

      const variantID = $(".ProductForm__Variants select")
        .find(":selected")
        .val();
      const apiCalls = [];

      // Subscribe to customer emails if checkbox is checked
      if (document.querySelector("input#coming_soon_bis-newsletter").checked) {
        apiCalls.push(
          this.subscribeToAList(
            email,
            this.config.LIST_IDS.CUSTOMER_EMAILS,
            "Customer Emails",
            "Coming soon form"
          )
        );
      }

      // Add back in stock subscription
      apiCalls.push(this.backInStockSubscription(email, variantID));

      try {
        await Promise.all(apiCalls);
        this.updateComingSoonUI();
      } catch (error) {
        console.error("[Klaviyo] Form submission failed", {
          error: error.message,
        });
      }
    }

    // Register back in stock notification for a specific variant
    // API docs: https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
    async backInStockSubscription(email, variantID) {
      if (!this.config.PUBLIC_API_KEY || !email || !variantID) {
        const error = new Error("Missing required parameters");
        this.onBackInStockError(error, email, variantID);
        throw error;
      }

      const endpoint = `${this.config.ENDPOINTS.BACK_IN_STOCK}?company_id=${this.config.PUBLIC_API_KEY}`;
      const body = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: { email },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantID}`,
              },
            },
          },
        },
      };

      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          revision: "2024-02-15",
        },
        body: JSON.stringify(body),
        mode: "cors",
        credentials: "omit",
      };

      try {
        const response = await fetch(endpoint, options);
        if (!response.ok) throw new Error("Network response was not ok");

        this.onBackInStockSuccess(email, variantID);
        return response;
      } catch (error) {
        this.onBackInStockError(error, email, variantID);
        throw error;
      }
    }

    // Subscribe email to a specific Klaviyo list
    // API docs: https://developers.klaviyo.com/en/reference/create_client_subscription
    async subscribeToAList(email, listId, listName, source) {
      if (!this.config.PUBLIC_API_KEY || !email || !listId) {
        const error = new Error("Missing required parameters");
        this.onListSubscriptionError(error, email, listId);
        throw error;
      }

      const endpoint = `${this.config.ENDPOINTS.SUBSCRIPTION}?company_id=${this.config.PUBLIC_API_KEY}`;
      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId,
              },
            },
          },
        },
      };

      const options = {
        method: "POST",
        headers: {
          revision: "2024-10-15",
          "content-type": "application/vnd.api+json",
        },
        body: JSON.stringify(payload),
      };

      try {
        const response = await fetch(endpoint, options);
        if (!response.ok) throw new Error("Network response was not ok");

        this.onListSubscriptionSuccess(email, listName, source);
        return response;
      } catch (error) {
        this.onListSubscriptionError(error, email, listId);
        throw error;
      }
    }
  }

  new KlaviyoApiHandler();
})();
